import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 17a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2l0 -2","key":"svg-0"}],["path",{"d":"M15 17a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2l0 -2","key":"svg-1"}],["path",{"d":"M9 5a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v2a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2l0 -2","key":"svg-2"}],["path",{"d":"M6 15v-1a2 2 0 0 1 2 -2h8a2 2 0 0 1 2 2v1","key":"svg-3"}],["path",{"d":"M12 9l0 3","key":"svg-4"}]]

const IconSitemap = createReactComponent('outline', 'sitemap', 'Sitemap', __iconNode);

export default IconSitemap;